// extracted by mini-css-extract-plugin
export default {"imageWrapper":"uM-z","twoColumnImage":"vM-z"};